import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner container">
        <div className="footer__brand">
          <div className="footer__logo">
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
              <polygon points="16,2 30,10 30,22 16,30 2,22 2,10" fill="none" stroke="#00c8ff" strokeWidth="2"/>
              <circle cx="16" cy="16" r="5" fill="#00c8ff"/>
              <line x1="16" y1="7" x2="16" y2="11" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="16" y1="21" x2="16" y2="25" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="7.3" y1="11.5" x2="10.7" y2="13.5" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="21.3" y1="18.5" x2="24.7" y2="20.5" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="7.3" y1="20.5" x2="10.7" y2="18.5" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="21.3" y1="13.5" x2="24.7" y2="11.5" stroke="#00c8ff" strokeWidth="1.5"/>
            </svg>
            <span>GT <span style={{ color: 'var(--color-accent)' }}>Expression</span></span>
          </div>
          <p className="footer__tagline">
            Delivering cloud-native excellence — CI/CD pipelines, Kubernetes orchestration, and multi-cloud infrastructure on AWS, Azure &amp; GKE.
          </p>
        </div>

        <div className="footer__nav">
          <div className="footer__col">
            <h4>Company</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/platforms">Platforms</Link>
          </div>
          <div className="footer__col">
            <h4>Services</h4>
            <Link to="/services">CI/CD Design</Link>
            <Link to="/services">Kubernetes Setup</Link>
            <Link to="/services">IaC & Terraform</Link>
            <Link to="/services">Cloud Migration</Link>
          </div>
          <div className="footer__col">
            <h4>Platforms</h4>
            <Link to="/platforms">AWS EKS</Link>
            <Link to="/platforms">Azure AKS</Link>
            <Link to="/platforms">Google GKE</Link>
            <Link to="/platforms">Multi-Cloud</Link>
          </div>
        </div>
      </div>

      <div className="footer__bottom container">
        <p>© {new Date().getFullYear()} GT Expression. All rights reserved.</p>
        <p>Built for cloud-native teams.</p>
      </div>
    </footer>
  )
}
